// Ray backgrounds — vanilla raw-WebGL ports of React Bits <SideRays/> and
// <LightRays/> (ogl replaced by ~40 lines of boilerplate; shaders verbatim).
// One fixed, pointer-transparent, screen-blended canvas per page.
// Configure via the including <script> tag:
//   data-mode="side"  data-color1="#C9A227" data-color2="#7FA8D0" [data-origin]
//   data-mode="light" data-color="#D2A23A" [data-origin]
(function () {
  var s = document.currentScript;
  if (!s || !s.dataset.mode) return;
  var mode = s.dataset.mode;

  function rgb(hex) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
    return m ? [parseInt(m[1], 16) / 255, parseInt(m[2], 16) / 255, parseInt(m[3], 16) / 255] : [1, 1, 1];
  }

  var VERT = 'attribute vec2 position;varying vec2 vUv;void main(){vUv=position*0.5+0.5;gl_Position=vec4(position,0.,1.);}';

  var SIDE_FRAG = 'precision highp float;\n' +
'uniform float iTime;uniform vec2 iResolution;uniform float iSpeed;uniform vec3 iRayColor1;uniform vec3 iRayColor2;\n' +
'uniform float iIntensity;uniform float iSpread;uniform float iFlipX;uniform float iFlipY;uniform float iTilt;\n' +
'uniform float iSaturation;uniform float iBlend;uniform float iFalloff;uniform float iOpacity;\n' +
'float rayStrength(vec2 raySource, vec2 rayRefDirection, vec2 coord, float seedA, float seedB, float speed){\n' +
'  vec2 sourceToCoord = coord - raySource;\n' +
'  float cosAngle = dot(normalize(sourceToCoord), rayRefDirection);\n' +
'  return clamp((0.45 + 0.15 * sin(cosAngle * seedA + iTime * speed)) + (0.3 + 0.2 * cos(-cosAngle * seedB + iTime * speed)), 0.0, 1.0) *\n' +
'    clamp((iResolution.x - length(sourceToCoord)) / iResolution.x, 0.5, 1.0);\n' +
'}\n' +
'void main(){\n' +
'  vec2 fragCoord = gl_FragCoord.xy;\n' +
'  if (iFlipX > 0.5) fragCoord.x = iResolution.x - fragCoord.x;\n' +
'  if (iFlipY > 0.5) fragCoord.y = iResolution.y - fragCoord.y;\n' +
'  vec2 coord = vec2(fragCoord.x, iResolution.y - fragCoord.y);\n' +
'  vec2 rayPos = vec2(iResolution.x * 1.1, -0.5 * iResolution.y);\n' +
'  float tiltRad = iTilt * 3.14159265 / 180.0;\n' +
'  float cs = cos(tiltRad); float sn = sin(tiltRad);\n' +
'  vec2 rel = coord - rayPos;\n' +
'  vec2 tiltedCoord = vec2(rel.x * cs - rel.y * sn, rel.x * sn + rel.y * cs) + rayPos;\n' +
'  float halfSpread = iSpread * 0.275;\n' +
'  vec2 rayRefDir1 = normalize(vec2(cos(0.785398 + halfSpread), sin(0.785398 + halfSpread)));\n' +
'  vec2 rayRefDir2 = normalize(vec2(cos(0.785398 - halfSpread), sin(0.785398 - halfSpread)));\n' +
'  vec4 rays1 = vec4(iRayColor1, 1.0) * rayStrength(rayPos, rayRefDir1, tiltedCoord, 36.2214, 21.11349, iSpeed);\n' +
'  vec4 rays2 = vec4(iRayColor2, 1.0) * rayStrength(rayPos, rayRefDir2, tiltedCoord, 22.3991, 18.0234, iSpeed * 0.2);\n' +
'  vec4 color = rays1 * (1.0 - iBlend) * 0.9 + rays2 * iBlend * 0.9;\n' +
'  float distanceToLight = length(fragCoord.xy - vec2(rayPos.x, iResolution.y - rayPos.y)) / iResolution.y;\n' +
'  float brightness = iIntensity * 0.4 / pow(max(distanceToLight, 0.001), iFalloff);\n' +
'  color.rgb *= brightness;\n' +
'  float gray = dot(color.rgb, vec3(0.299, 0.587, 0.114));\n' +
'  color.rgb = mix(vec3(gray), color.rgb, iSaturation);\n' +
'  color.a = max(color.r, max(color.g, color.b)) * iOpacity;\n' +
'  gl_FragColor = color;\n' +
'}';

  var LIGHT_FRAG = 'precision highp float;\n' +
'uniform float iTime;uniform vec2 iResolution;uniform vec2 rayPos;uniform vec2 rayDir;uniform vec3 raysColor;\n' +
'uniform float raysSpeed;uniform float lightSpread;uniform float rayLength;uniform float pulsating;\n' +
'uniform float fadeDistance;uniform float saturation;uniform vec2 mousePos;uniform float mouseInfluence;\n' +
'uniform float noiseAmount;uniform float distortion;\n' +
'float noise(vec2 st){return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123);}\n' +
'float rayStrength(vec2 raySource, vec2 rayRefDirection, vec2 coord, float seedA, float seedB, float speed){\n' +
'  vec2 sourceToCoord = coord - raySource;\n' +
'  vec2 dirNorm = normalize(sourceToCoord);\n' +
'  float cosAngle = dot(dirNorm, rayRefDirection);\n' +
'  float distortedAngle = cosAngle + distortion * sin(iTime * 2.0 + length(sourceToCoord) * 0.01) * 0.2;\n' +
'  float spreadFactor = pow(max(distortedAngle, 0.0), 1.0 / max(lightSpread, 0.001));\n' +
'  float dist = length(sourceToCoord);\n' +
'  float maxDistance = iResolution.x * rayLength;\n' +
'  float lengthFalloff = clamp((maxDistance - dist) / maxDistance, 0.0, 1.0);\n' +
'  float fadeFalloff = clamp((iResolution.x * fadeDistance - dist) / (iResolution.x * fadeDistance), 0.5, 1.0);\n' +
'  float pulse = pulsating > 0.5 ? (0.8 + 0.2 * sin(iTime * speed * 3.0)) : 1.0;\n' +
'  float baseStrength = clamp((0.45 + 0.15 * sin(distortedAngle * seedA + iTime * speed)) + (0.3 + 0.2 * cos(-distortedAngle * seedB + iTime * speed)), 0.0, 1.0);\n' +
'  return baseStrength * lengthFalloff * fadeFalloff * spreadFactor * pulse;\n' +
'}\n' +
'void main(){\n' +
'  vec2 fragCoord = gl_FragCoord.xy;\n' +
'  vec2 coord = vec2(fragCoord.x, iResolution.y - fragCoord.y);\n' +
'  vec2 finalRayDir = rayDir;\n' +
'  if (mouseInfluence > 0.0) {\n' +
'    vec2 mouseScreenPos = mousePos * iResolution.xy;\n' +
'    vec2 mouseDirection = normalize(mouseScreenPos - rayPos);\n' +
'    finalRayDir = normalize(mix(rayDir, mouseDirection, mouseInfluence));\n' +
'  }\n' +
'  vec4 rays1 = vec4(1.0) * rayStrength(rayPos, finalRayDir, coord, 36.2214, 21.11349, 1.5 * raysSpeed);\n' +
'  vec4 rays2 = vec4(1.0) * rayStrength(rayPos, finalRayDir, coord, 22.3991, 18.0234, 1.1 * raysSpeed);\n' +
'  vec4 fragColor = rays1 * 0.5 + rays2 * 0.4;\n' +
'  if (noiseAmount > 0.0) {\n' +
'    float n = noise(coord * 0.01 + iTime * 0.1);\n' +
'    fragColor.rgb *= (1.0 - noiseAmount + noiseAmount * n);\n' +
'  }\n' +
'  float brightness = 1.0 - (coord.y / iResolution.y);\n' +
'  fragColor.x *= 0.1 + brightness * 0.8;\n' +
'  fragColor.y *= 0.3 + brightness * 0.6;\n' +
'  fragColor.z *= 0.5 + brightness * 0.5;\n' +
'  if (saturation != 1.0) {\n' +
'    float gray = dot(fragColor.rgb, vec3(0.299, 0.587, 0.114));\n' +
'    fragColor.rgb = mix(vec3(gray), fragColor.rgb, saturation);\n' +
'  }\n' +
'  fragColor.rgb *= raysColor;\n' +
'  gl_FragColor = fragColor;\n' +
'}';

  var PILLAR_FRAG = 'precision mediump float;\n' +
'uniform float iTime;uniform vec2 iResolution;uniform vec3 uTopColor;uniform vec3 uBottomColor;\n' +
'uniform float uIntensity;uniform float uGlowAmount;uniform float uPillarWidth;uniform float uPillarHeight;\n' +
'uniform float uNoiseIntensity;uniform float uRotCos;uniform float uRotSin;\n' +
'varying vec2 vUv;\n' +
'const float STEP_MULT = 1.2;\n' +
'const int MAX_ITER = 40;\n' +
'const int WAVE_ITER = 2;\n' +
'vec3 tanh3(vec3 x){vec3 e2=exp(2.0*clamp(x,-10.0,10.0));return (e2-1.0)/(e2+1.0);}\n' +
'void main() {\n' +
'  vec2 uv = (vUv * 2.0 - 1.0) * vec2(iResolution.x / iResolution.y, 1.0);\n' +
'  vec3 ro = vec3(0.0, 0.0, -10.0);\n' +
'  vec3 rd = normalize(vec3(uv, 1.0));\n' +
'  float uWaveSin = 0.38941834; float uWaveCos = 0.92106099;\n' +
'  vec3 col = vec3(0.0);\n' +
'  float t = 0.1;\n' +
'  for(int i = 0; i < MAX_ITER; i++) {\n' +
'    vec3 p = ro + rd * t;\n' +
'    p.xz = vec2(uRotCos * p.x - uRotSin * p.z, uRotSin * p.x + uRotCos * p.z);\n' +
'    vec3 q = p;\n' +
'    q.y = p.y * uPillarHeight + iTime;\n' +
'    float freq = 1.0;\n' +
'    float amp = 1.0;\n' +
'    for(int j = 0; j < WAVE_ITER; j++) {\n' +
'      q.xz = vec2(uWaveCos * q.x - uWaveSin * q.z, uWaveSin * q.x + uWaveCos * q.z);\n' +
'      q += cos(q.zxy * freq - iTime * float(j) * 2.0) * amp;\n' +
'      freq *= 2.0;\n' +
'      amp *= 0.5;\n' +
'    }\n' +
'    float d = length(cos(q.xz)) - 0.2;\n' +
'    float bound = length(p.xz) - uPillarWidth;\n' +
'    float k = 4.0;\n' +
'    float h = max(k - abs(d - bound), 0.0);\n' +
'    d = max(d, bound) + h * h * 0.0625 / k;\n' +
'    d = abs(d) * 0.15 + 0.01;\n' +
'    float grad = clamp((15.0 - p.y) / 30.0, 0.0, 1.0);\n' +
'    col += mix(uBottomColor, uTopColor, grad) / d;\n' +
'    t += d * STEP_MULT;\n' +
'    if(t > 50.0) break;\n' +
'  }\n' +
'  float widthNorm = uPillarWidth / 3.0;\n' +
'  col = tanh3(col * uGlowAmount / widthNorm);\n' +
'  col -= fract(sin(dot(gl_FragCoord.xy, vec2(12.9898, 78.233))) * 43758.5453) / 15.0 * uNoiseIntensity;\n' +
'  gl_FragColor = vec4(col * uIntensity, 1.0);\n' +
'}';

  var wrap = document.createElement('div');
  wrap.className = 'mz-rays';
  wrap.setAttribute('aria-hidden', 'true');
  var host = s.dataset.target && document.querySelector(s.dataset.target);
  if (host) {                                  // scoped to one section, not the page
    wrap.className += ' mz-rays-local';
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(wrap);
  } else {
    document.body.insertBefore(wrap, document.body.firstChild);
  }
  var canvas = document.createElement('canvas');
  wrap.appendChild(canvas);
  var gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: true });
  if (!gl) { wrap.remove(); return; }

  function sh(type, src) {
    var o = gl.createShader(type);
    gl.shaderSource(o, src); gl.compileShader(o);
    if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) { console.warn('rays shader:', gl.getShaderInfoLog(o)); return null; }
    return o;
  }
  var vs = sh(gl.VERTEX_SHADER, VERT);
  var fs = sh(gl.FRAGMENT_SHADER, mode === 'side' ? SIDE_FRAG : mode === 'pillar' ? PILLAR_FRAG : LIGHT_FRAG);
  if (!vs || !fs) { wrap.remove(); return; }
  var prog = gl.createProgram();
  gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
  gl.useProgram(prog);
  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'position');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  var U = {};
  function u(name) { return U[name] || (U[name] = gl.getUniformLocation(prog, name)); }

  var d = s.dataset;
  var dpr = Math.min(devicePixelRatio || 1, 2);
  var W = 1, H = 1;
  function resize() {
    W = wrap.clientWidth * dpr; H = wrap.clientHeight * dpr;
    canvas.width = W; canvas.height = H;
    canvas.style.width = '100%'; canvas.style.height = '100%';
    gl.viewport(0, 0, W, H);
  }
  addEventListener('resize', resize); resize();

  var mouse = { x: 0.5, y: 0.5 }, sm = { x: 0.5, y: 0.5 };
  if (mode === 'light') {
    addEventListener('mousemove', function (e) {
      mouse.x = e.clientX / innerWidth; mouse.y = e.clientY / innerHeight;
    }, { passive: true });
  }

  function anchorDir(origin, w, h) {
    var o = 0.2;
    switch (origin) {
      case 'top-left': return [[0, -o * h], [0, 1]];
      case 'top-right': return [[w, -o * h], [0, 1]];
      case 'left': return [[-o * w, 0.5 * h], [1, 0]];
      case 'right': return [[(1 + o) * w, 0.5 * h], [-1, 0]];
      case 'bottom-center': return [[0.5 * w, (1 + o) * h], [0, -1]];
      default: return [[0.5 * w, -o * h], [0, 1]];
    }
  }
  function flip(origin) {
    switch (origin) {
      case 'top-left': return [1, 0];
      case 'bottom-right': return [0, 1];
      case 'bottom-left': return [1, 1];
      default: return [0, 0];
    }
  }

  var visible = true;
  new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.05 }).observe(wrap);

  function frame(t) {
    requestAnimationFrame(frame);
    if (!visible) return;
    gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
    gl.uniform1f(u('iTime'), t * 0.001);
    gl.uniform2f(u('iResolution'), W, H);
    if (mode === 'pillar') {
      var pt = t * 0.001 * +(d.speed || 0.3);
      gl.uniform1f(u('iTime'), pt);
      gl.uniform1f(u('uRotCos'), Math.cos(pt * 0.3));
      gl.uniform1f(u('uRotSin'), Math.sin(pt * 0.3));
      gl.uniform3fv(u('uTopColor'), rgb(d.top || '#5227FF'));
      gl.uniform3fv(u('uBottomColor'), rgb(d.bottom || '#FF9FFC'));
      gl.uniform1f(u('uIntensity'), +(d.intensity || 1));
      gl.uniform1f(u('uGlowAmount'), +(d.glow || 0.005));
      gl.uniform1f(u('uPillarWidth'), +(d.width || 3));
      gl.uniform1f(u('uPillarHeight'), +(d.height || 0.4));
      gl.uniform1f(u('uNoiseIntensity'), +(d.noise || 0.4));
    } else if (mode === 'side') {
      var f = flip(d.origin || 'top-right');
      gl.uniform1f(u('iSpeed'), +(d.speed || 1.6));
      gl.uniform3fv(u('iRayColor1'), rgb(d.color1 || '#C9A227'));
      gl.uniform3fv(u('iRayColor2'), rgb(d.color2 || '#7FA8D0'));
      gl.uniform1f(u('iIntensity'), +(d.intensity || 1.4));
      gl.uniform1f(u('iSpread'), +(d.spread || 2));
      gl.uniform1f(u('iFlipX'), f[0]); gl.uniform1f(u('iFlipY'), f[1]);
      gl.uniform1f(u('iTilt'), +(d.tilt || 0));
      gl.uniform1f(u('iSaturation'), +(d.saturation || 1.2));
      gl.uniform1f(u('iBlend'), +(d.blend || 0.6));
      gl.uniform1f(u('iFalloff'), +(d.falloff || 1.6));
      gl.uniform1f(u('iOpacity'), +(d.opacity || 0.85));
    } else {
      var ad = anchorDir(d.origin || 'top-center', W, H);
      gl.uniform2fv(u('rayPos'), ad[0]);
      gl.uniform2fv(u('rayDir'), ad[1]);
      gl.uniform3fv(u('raysColor'), rgb(d.color || '#FFFFFF'));
      gl.uniform1f(u('raysSpeed'), +(d.speed || 1));
      gl.uniform1f(u('lightSpread'), +(d.spread || 1.2));
      gl.uniform1f(u('rayLength'), +(d.length || 2));
      gl.uniform1f(u('pulsating'), 0);
      gl.uniform1f(u('fadeDistance'), 1);
      gl.uniform1f(u('saturation'), 1);
      sm.x = sm.x * 0.92 + mouse.x * 0.08;
      sm.y = sm.y * 0.92 + mouse.y * 0.08;
      gl.uniform2f(u('mousePos'), sm.x, sm.y);
      gl.uniform1f(u('mouseInfluence'), +(d.influence || 0.1));
      gl.uniform1f(u('noiseAmount'), +(d.noise || 0));
      gl.uniform1f(u('distortion'), +(d.distortion || 0));
    }
    gl.drawArrays(gl.TRIANGLES, 0, 3);
  }
  requestAnimationFrame(frame);
})();
